const container_style = "width:100%;height:100%;padding:0;margin:0;position:relative;";
const user_image_style = "width:100%;background:#fff;";
const asset_position_style = "position:absolute;top:100%;left:0;";
const temple_transform_origin_style = "transform-origin: left center;";
const temple_anti_alias = "image-rendering: pixelated;image-rendering: -moz-crisp-edges;";
const absolute_center = "position: absolute; left: 0;right: 0;bottom: 0;top: 0;margin: auto;";

export default `
    <div class="xj-tryon-container" style="${ container_style }">
  		<img class="xj-u-img" data-xj="usr" style="${ user_image_style }${ absolute_center }" ></img>
  		<img class="xj-tmpl-img xj-tmpl-img-l" data-xj="lt" style="${ asset_position_style }${ temple_transform_origin_style }${ temple_anti_alias }" ></img>
  		<img class="xj-tmpl-img xj-tmpl-img-r" data-xj="rt" style="${ asset_position_style }${ temple_transform_origin_style }${ temple_anti_alias }" ></img>
  		<img class="xj-fr-img" data-xj="fr" style="${ asset_position_style }" ></img>
    </div>
`;